import script from "./Ichi.vue?vue&type=script&lang=js"
export * from "./Ichi.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__